export const SenderRoutes = [
  {
    path: '',
    name: 'move order sender list',
    component: () => import('@/views/app/move-order/sender/list/page-list.vue'),
    meta: { title: 'Daftar Pengiriman Barang' },
  },
  {
    path: ':id',
    name: 'move order sender detail',
    component: () => import('@/views/app/move-order/sender/detail/page-detail.vue'),
    meta: { title: 'Detail Pengiriman Barang' },
  },
  {
    path: ':id/edit',
    name: 'move order sender edit',
    component: () => import('@/views/app/move-order/sender/edit/page-edit.vue'),
    meta: { title: 'Edit Pengiriman Barang' },
  },
]

export const ReceiverRoutes = [
  {
    path: '',
    name: 'move order receiver list',
    component: () => import('@/views/app/move-order/receiver/list/page-list.vue'),
    meta: { title: 'Daftar Penerimaan Barang' },
  },
  {
    path: 'receipt/:id',
    name: 'move order receipt detail',
    component: () => import('@/views/app/move-order/receiver/receipt/page-detail.vue'),
    meta: { title: 'Detail Riwayat Penerimaan Barang' },
  },
  {
    path: ':id',
    name: 'move order receiver detail',
    component: () => import('@/views/app/move-order/receiver/detail/page-detail.vue'),
    meta: { title: 'Detail Penerimaan Barang' },
  },
]

export const PendingRoutes = [
  {
    path: 'product-pending',
    name: 'move order product pending',
    component: () => import('@/views/app/move-order/product-pending/page-list.vue'),
    meta: { title: 'Produk Pending Mutasi' },
  },
]

